import { getBackgroundShade, IButtonStyles, ICheckboxStyles, IComboBoxStyles, initializeIcons, ISeparatorStyles, ISpinButton, ISpinButtonStyles, IStyle, ITextFieldStyles, IToggleStyles, PartialTheme, Separator, Stack, ThemeProvider } from '@fluentui/react';
import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes } from 'react-router-dom';
import { InferencePriority } from 'typescript';
import MenuView from './App/Menu/MenuView';
import ConfigureService from './Services/ConfigureService'

interface IAppProps {
    minHeight?: string | number    
}

initializeIcons();

const init = require('./Stores/init');
const store = init.configureStore();

const separatorStyle: ISeparatorStyles = {
    root: [{
        fontFamily: "Comfortaa, serif",
        fontSize: '24px'
    },
    {
        selectors: {
            '::before': {
                background: '#007dad',
                height: 2
            },
        },
        width: '100%'
    }
    ], content: {}
};

const primaryButtonStyle: IButtonStyles = {
    root: {
        width: 150,
        borderRadius:8,
        '&::after': {
            borderColor: '#007dad',
            
        }
    },
    rootHovered: {
        backgroundColor: '#006494'
    }
}

const buttonStyle: IButtonStyles = {
    root: {
        width: 150,
        borderRadius: 8,
         
    },
  
}


const textFieldStyles: Partial<ITextFieldStyles> = {
    fieldGroup: {
        borderColor: '#007dad',
        borderRadius: 8,
        '&::after': { borderColor: '#007dad', borderRadius: 8},

    },
    subComponentStyles: { label: { root: { fontSize: 12, color: '#007dad', fontFamily: "Comfortaa, serif", } }, }
};

const spinButtonStyle: Partial<ISpinButtonStyles> = {
    label: {
        color: '#007dad',
        fontFamily: "Comfortaa, serif",
        fontSize: 12,
    },
    spinButtonWrapper:
    {
        fontFamily: "Comfortaa, serif",

        '&::after': {
            borderColor: '#007dad'
            
        }
    },

}

const toggleStyle: Partial<IToggleStyles> = {
    label: {
        color: '#007dad',
        fontFamily: "Comfortaa, serif",
        fontSize: 12,
    },
}
const comboBoxStyle: Partial<IComboBoxStyles> = {
    label: {
        color: '#007dad',
        fontFamily: "Comfortaa, serif",
        fontSize:12
    },
    rootFocused: {
        '&::after': { borderColor: '#007dad' },
        fontFamily: "Comfortaa, serif",
    }
}

const checkBoxStyle: Partial<ICheckboxStyles> = {
    label: {
        color: '#007dad',
        fontFamily: "Comfortaa, serif",
    },
    text: { color: '#007dad' }

}

const appTheme: PartialTheme = {
    palette: {
        blue: '#007dad',
        blueDark:'#004A7A',
        themePrimary: '#007dad'

    },
    components: {
        TextField: { styles: textFieldStyles },
        Separator: { styles: separatorStyle },
        ComboBox: { styles: comboBoxStyle },
        PrimaryButton: { styles: primaryButtonStyle },
        SpinButton: { styles: spinButtonStyle },
        Checkbox: { styles: checkBoxStyle },
        Toggle: { styles: toggleStyle },
        DefaultButton: { styles: buttonStyle }
    }
};

export const App: React.FC<IAppProps> = props => {
    return <div className="App">
        <ThemeProvider theme={appTheme} style={{ minHeight: (props.minHeight != undefined ? props.minHeight : 'calc(100vh - 258px)') }}>
            <BrowserRouter>
                <Provider store={store}>
                     <ConfigureService>
                         {props.children}
                     </ConfigureService>
                </Provider>
            </BrowserRouter>
        </ThemeProvider>
    </div>;
}
